import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";

export class OrganisationAdmin{
  constructor(
    public id:string,
    public firstName:string = "",
    public lastName:string = "",
    public email:string = "",
    public communicationEmail:string = "",
    public image:string = ""
  ){}

  public getName(){
    return this.lastName + ' ' + this.firstName;
  }
}


@Injectable({
  providedIn: 'root'
})

export class OrganisationAdminAdapter implements Adapter<OrganisationAdmin> {
  constructor() {
  }

  adapt(item: any): OrganisationAdmin {
    
    return new OrganisationAdmin(
      item.id,
      item.firstName.trim(),
      item.lastName.trim(),
      item.emailAddress,      
      item.communicationEmailAddress??'',
      item.image??''
    );
  }
}
